import axios, { AxiosRequestConfig } from "axios";
import Logger from "../Logger/Logger";
import Validator from "../Validator/Validator";
import { HttpResultPojo } from "./HttpResultPojo";
import { LOCALE_LANGUAGE } from "../../Constant";

export default class HttpService {

    private axiosInstance;
    private validator = new Validator();
    private logger = new Logger();

    constructor() {
        this.axiosInstance = axios.create({
            baseURL: "",
            withCredentials: true,
        });
        this.axiosInstance.interceptors.request.use((config) => {
            if(!config.headers) {
                config.headers = {};
            }
            config.headers["Accept-Language"] = LOCALE_LANGUAGE;
            return config;
        });
    }

    private isRequestSuccessful(status: number): boolean {
        return status >= 200 && status <= 299;
    }

    async get(apiEndpoint: string, params: object): Promise<HttpResultPojo> {
        try {
            this.validator.isValidString("apiEndpoint", apiEndpoint);
            const result = await this.axiosInstance.get(apiEndpoint, { params });
            return {
                data: result.data,
                status: result.status,
                isRequestSuccessful: this.isRequestSuccessful(result.status),
            };
        } catch (error) {
            this.logger.error(error);
            throw error;
        }
    }

    async post(apiEndpoint: string, params: object): Promise<HttpResultPojo> {
        try {
            this.validator.isValidString("apiEndpoint", apiEndpoint);
            const result = await this.axiosInstance.post(apiEndpoint, params);
            return {
                data: result.data,
                status: result.status,
                isRequestSuccessful: this.isRequestSuccessful(result.status),
            };
        } catch (error) {
            this.logger.error(error);
            throw error;
        }
    }

    async postFormData(apiEndpoint: string, formData: any): Promise<HttpResultPojo> {
        try {
            this.validator.isValidString("apiEndpoint", apiEndpoint);

            const result = await this.axiosInstance.post(apiEndpoint, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            return {
                data: result.data,
                status: result.status,
                isRequestSuccessful: this.isRequestSuccessful(result.status),
            };
        } catch (error) {
            this.logger.error(error);
            throw error;
        }
    }

    async put(apiEndpoint: string, params: object): Promise<HttpResultPojo> {
        try {
            this.validator.isValidString("apiEndpoint", apiEndpoint);

            const result = await this.axiosInstance.put(apiEndpoint, params);

            return {
                data: result.data,
                status: result.status,
                isRequestSuccessful: this.isRequestSuccessful(result.status),
            };
        } catch (error) {
            this.logger.error(error);
            throw error;
        }
    }

    async delete(apiEndpoint: string, params: object): Promise<HttpResultPojo> {
        try {
            this.validator.isValidString("apiEndpoint", apiEndpoint);

            const result = await this.axiosInstance.delete(apiEndpoint, { params });

            return {
                data: result.data,
                status: result.status,
                isRequestSuccessful: this.isRequestSuccessful(result.status),
            };
        } catch (error) {
            this.logger.error(error);
            throw error;
        }
    }
}
